import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import baseuri from '../../baseuri';
import { randomgen } from '../../utils/general-utils';
import { addToLoadingQueue, removeFromLoadingQueue } from './general';

export const retrieveAdminUnremittedBalances = createAsyncThunk(
	'adminUnremittedBalances/retrieveAdminUnremittedBalances',
	async (params: any, { dispatch }) => {
		const loadingId = randomgen();
		dispatch(addToLoadingQueue(loadingId));
		try {
			const res = await baseuri.get('/admin/unremitted-balances', { params });
			dispatch(removeFromLoadingQueue(loadingId));
			return res.data.data;
		} catch (error) {
			dispatch(removeFromLoadingQueue(loadingId));
			throw error;
		}
	}
);

const adminUnremittedBalancesRx = createSlice({
	name: 'adminUnremittedBalances',
	initialState: {
		unremittedBalances: {
			details: {
				itemsList: [],
				paginator: { currentPage: 1, itemCount: 0, perPage: 20 },
			},
			result: [],
		},
	},
	reducers: {},
	extraReducers: (builder) =>
		builder.addCase(retrieveAdminUnremittedBalances.fulfilled, (state, action) => {
			const store = state;
			store.unremittedBalances = action.payload;
		}),
});

export default adminUnremittedBalancesRx.reducer;
